import StaticFluidsPic from '../../Images/StaticFluids.jpg'

const S = {
  wrapper: { marginTop:'10px', padding:'40px', border:'3px solid grey', fontFamily:"'Georgia', serif", color:'#1a1a2e', lineHeight:'1.7' },
  h1: { fontSize:'2rem', fontWeight:'700', borderBottom:'3px solid #c0392b', paddingBottom:'8px', marginBottom:'24px', color:'#7B0D0D' },
  h2: { fontSize:'1.3rem', fontWeight:'700', color:'#c0392b', marginTop:'36px', marginBottom:'12px', borderLeft:'4px solid #c0392b', paddingLeft:'10px' },
  p: { marginBottom:'12px', fontSize:'0.97rem' },
  infoBox: { background:'#FEF0F0', border:'2px solid #c0392b', borderRadius:'6px', padding:'16px 20px', margin:'16px 0' },
  infoBoxTitle: { fontWeight:'700', fontFamily:"'Courier New', monospace", fontSize:'0.88rem', color:'#7B0D0D', marginBottom:'8px' },
  infoBoxItem: { fontSize:'0.9rem', margin:'4px 0', paddingLeft:'12px', borderLeft:'2px solid #c0392b' },
  table: { width:'100%', borderCollapse:'collapse', marginBottom:'20px', fontSize:'0.92rem' },
  th: { background:'#c0392b', color:'#fff', padding:'10px 14px', textAlign:'left', fontWeight:'700', fontSize:'0.9rem' },
  tdE: { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff5f5' },
  tdO: { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff' },
  tdL: { fontWeight:'600', color:'#7B0D0D', whiteSpace:'nowrap', width:'220px' },
  code: { fontFamily:"'Courier New', monospace", fontSize:'0.88rem', whiteSpace:'pre-wrap' },
  dWrap: { margin:'24px 0', background:'#fffafa', border:'1px solid #f0cece', borderRadius:'8px', padding:'20px' },
  dTitle: { fontWeight:'700', fontSize:'0.95rem', color:'#7B0D0D', marginBottom:'12px', textAlign:'center', letterSpacing:'0.02em' },
  dCaption: { fontSize:'0.84rem', color:'#555', textAlign:'center', marginTop:'10px', fontStyle:'italic' },
};

function InfoBox({ title, items }) {
  return (
    <div style={S.infoBox}>
      <div style={S.infoBoxTitle}>{title}</div>
      {items.map((item, i) => <div key={i} style={S.infoBoxItem}>{item}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table style={S.table}>
      <thead><tr>
        <th style={{ ...S.th, width:'220px' }}>Concept</th>
        <th style={S.th}>Explanation / Formula</th>
      </tr></thead>
      <tbody>
        {rows.map(([label, content], i) => (
          <tr key={i}>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.tdL }}>{label}</td>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.code }}>{content}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// ── Diagram: Hydrostatic Pressure with Depth ───────────────────────
function DiagramHydrostaticPressure() {
  const W = 680, H = 320;
  const layers = [
    { y: 80,  h: 40, label: 'h₁', p: 'P₁ = P₀ + ρgh₁', opacity: 0.30 },
    { y: 120, h: 40, label: 'h₂', p: 'P₂ = P₀ + ρgh₂', opacity: 0.48 },
    { y: 160, h: 40, label: 'h₃', p: 'P₃ = P₀ + ρgh₃', opacity: 0.64 },
    { y: 200, h: 40, label: 'h₄', p: 'P₄ = P₀ + ρgh₄', opacity: 0.82 },
  ];
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Hydrostatic Pressure Increases Linearly with Depth</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arrH" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#555"/>
          </marker>
          <marker id="arrHT" markerWidth="7" markerHeight="7" refX="1" refY="3.5" orient="auto">
            <polygon points="6 0, 0 3.5, 6 7" fill="#555"/>
          </marker>
          <marker id="arrHRed" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#c0392b"/>
          </marker>
        </defs>

        {/* Container walls */}
        <rect x="80" y="60" width="260" height="200" rx="4" fill="none" stroke="#8aadcc" strokeWidth="2"/>

        {/* Free surface label */}
        <text x="210" y="52" textAnchor="middle" fontFamily="Georgia,serif" fontSize="12" fill="#888" fontStyle="italic">P₀ (atmospheric)</text>
        <line x1="80" y1="60" x2="340" y2="60" stroke="#2980b9" strokeWidth="1.5" strokeDasharray="5 3"/>

        {/* Water layers with increasing opacity */}
        {layers.map(({ y, h, opacity }) => (
          <rect key={y} x="82" y={y} width="256" height={h} fill="#2980b9" opacity={opacity}/>
        ))}

        {/* Pressure arrows on right + labels */}
        {layers.map(({ y, h, label, p }, i) => {
          const cy = y + h / 2;
          const len = 52 + i * 30;
          return (
            <g key={y}>
              <line x1="50" y1="60" x2="50" y2={cy} stroke="#c0392b" strokeWidth="0.8" strokeDasharray="3 2"/>
              <text x="38" y={cy + 4} textAnchor="end" fontFamily="Courier New,monospace" fontSize="11" fill="#c0392b">{label}</text>
              <line x1="342" y1={cy} x2={342 + len} y2={cy}
                stroke="#c0392b" strokeWidth={1.3 + i * 0.35} markerEnd="url(#arrHRed)"/>
              <text x={342 + len + 6} y={cy + 4} fontFamily="Courier New,monospace" fontSize="10" fill="#7B0D0D">{p}</text>
            </g>
          );
        })}

        {/* Depth axis */}
        <line x1="50" y1="60" x2="50" y2="268" stroke="#555" strokeWidth="1" markerEnd="url(#arrH)"/>
        <text x="36" y="278" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#555">depth</text>

        {/* Tank floor */}
        <rect x="80" y="258" width="260" height="8" rx="2" fill="#8aadcc" opacity="0.5"/>

        {/* Key formula */}
        <rect x="80" y="278" width="260" height="32" rx="6" fill="#FEF0F0" stroke="#c0392b" strokeWidth="1"/>
        <text x="210" y="299" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="13" fontWeight="700" fill="#7B0D0D">P = P₀ + ρgh</text>
      </svg>
      <div style={S.dCaption}>
        Pressure increases linearly with depth h. The arrows on the right show the growing pressure at each layer.
        Crucially, pressure at any depth is the same regardless of container shape — the hydrostatic paradox.
      </div>
    </div>
  );
}

// ── Diagram: U-tube Manometer ──────────────────────────────────────
function DiagramManometer() {
  const W = 680, H = 300;
  return (
    <div style={S.dWrap}>
     <div style={{ textAlign: "center" }}>
  <img src={StaticFluidsPic} alt="basic dimensions" width="60%" />
</div>
      <div style={S.dTitle}>U-Tube Manometer — Measuring Gauge Pressure</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arrM" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#c0392b"/>
          </marker>
          <marker id="arrMB" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#555"/>
          </marker>
          <marker id="arrMT" markerWidth="7" markerHeight="7" refX="1" refY="3.5" orient="auto">
            <polygon points="6 0, 0 3.5, 6 7" fill="#555"/>
          </marker>
        </defs>

        {/* Left arm */}
        <rect x="120" y="50" width="30" height="200" rx="3" fill="none" stroke="#8aadcc" strokeWidth="2"/>
        {/* Right arm */}
        <rect x="240" y="80" width="30" height="170" rx="3" fill="none" stroke="#8aadcc" strokeWidth="2"/>
        {/* U-bend bottom */}
        <path d="M120 250 Q120 272 135 272 Q150 272 150 250" fill="none" stroke="#8aadcc" strokeWidth="2"/>
        <path d="M270 250 Q270 272 255 272 Q240 272 240 250" fill="none" stroke="#8aadcc" strokeWidth="2"/>
        <line x1="150" y1="272" x2="240" y2="272" stroke="#8aadcc" strokeWidth="2"/>

        {/* Process fluid (blue) in left arm */}
        <rect x="122" y="80" width="26" height="120" fill="#2980b9" opacity="0.40" rx="2"/>
        {/* Manometer fluid (red/dense) in bottom + right arm */}
        <rect x="122" y="200" width="26" height="50" fill="#c0392b" opacity="0.50"/>
        <rect x="150" y="242" width="90" height="30" fill="#c0392b" opacity="0.50"/>
        <rect x="242" y="130" width="26" height="140" fill="#c0392b" opacity="0.50" rx="2"/>

        {/* Height difference Δh */}
        <line x1="312" y1="130" x2="312" y2="200" stroke="#555" strokeWidth="1"
          markerEnd="url(#arrMB)" markerStart="url(#arrMT)"/>
        <text x="324" y="170" fontFamily="Courier New,monospace" fontSize="12" fill="#333">Δh</text>

        {/* Pressure P applied left */}
        <line x1="78" y1="64" x2="118" y2="64" stroke="#c0392b" strokeWidth="1.8" markerEnd="url(#arrM)"/>
        <text x="28" y="68" fontFamily="Georgia,serif" fontSize="14" fontWeight="700" fill="#7B0D0D">P</text>

        {/* Atmosphere right */}
        <text x="256" y="72" fontFamily="Georgia,serif" fontSize="11" fill="#888" fontStyle="italic">P₀</text>

        {/* Fluid labels */}
        <text x="108" y="144" textAnchor="end" fontFamily="Georgia,serif" fontSize="11" fill="#2980b9" fontStyle="italic">process fluid ρ₁</text>
        <text x="108" y="218" textAnchor="end" fontFamily="Georgia,serif" fontSize="11" fill="#c0392b" fontStyle="italic">manometer fluid ρ_m</text>

        {/* Datum */}
        <line x1="120" y1="200" x2="350" y2="200" stroke="#555" strokeWidth="0.8" strokeDasharray="4 3"/>
        <text x="354" y="204" fontFamily="Georgia,serif" fontSize="10" fill="#888">datum</text>

        {/* Formula box */}
        <rect x="360" y="100" width="296" height="90" rx="6" fill="#FEF0F0" stroke="#c0392b" strokeWidth="1"/>
        <text x="508" y="126" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="13" fontWeight="700" fill="#7B0D0D">P_gauge = ρ_m g Δh</text>
        <line x1="370" y1="136" x2="646" y2="136" stroke="#f0cece" strokeWidth="1"/>
        <text x="508" y="154" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#555">ρ_m = manometer fluid density</text>
        <text x="508" y="171" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#555">Δh = height difference [m]</text>
      </svg>
      <div style={S.dCaption}>
        The pressure P pushes the manometer fluid down on the left and up on the right.
        At the datum, pressures must balance: P + ρ₁g h₁ = P₀ + ρ_m g h₂, giving P_gauge = ρ_m g Δh.
      </div>
    </div>
  );
}

// ── Diagram: Force on Submerged Inclined Plane ─────────────────────
function DiagramSubmergedPlane() {
  const W = 680, H = 320;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Hydrostatic Force on a Submerged Inclined Plane Surface</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arrPR" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#c0392b"/>
          </marker>
          <marker id="arrPB" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#555"/>
          </marker>
          <marker id="arrPT" markerWidth="7" markerHeight="7" refX="1" refY="3.5" orient="auto">
            <polygon points="6 0, 0 3.5, 6 7" fill="#555"/>
          </marker>
        </defs>

        {/* Free surface */}
        <line x1="40" y1="50" x2="400" y2="50" stroke="#2980b9" strokeWidth="1.5" strokeDasharray="6 3"/>
        <text x="42" y="44" fontFamily="Georgia,serif" fontSize="11" fill="#2980b9" fontStyle="italic">free surface</text>

        {/* Water body */}
        <rect x="40" y="50" width="360" height="240" fill="#2980b9" opacity="0.10"/>

        {/* Inclined plate */}
        <line x1="180" y1="70" x2="300" y2="250" stroke="#7B0D0D" strokeWidth="4" strokeLinecap="round"/>

        {/* Distributed pressure arrows (perpendicular to plate, increasing with depth) */}
        {[
          { x:188, y:88,  dx:-20, dy:14, w:1.0 },
          { x:204, y:112, dx:-26, dy:18, w:1.3 },
          { x:220, y:136, dx:-32, dy:23, w:1.6 },
          { x:236, y:160, dx:-38, dy:27, w:1.9 },
          { x:252, y:184, dx:-44, dy:31, w:2.2 },
          { x:268, y:208, dx:-50, dy:35, w:2.5 },
          { x:284, y:232, dx:-56, dy:40, w:2.8 },
        ].map(({ x, y, dx, dy, w }, i) => (
          <line key={i} x1={x+dx} y1={y-dy} x2={x} y2={y}
            stroke="#c0392b" strokeWidth={w} opacity="0.65" markerEnd="url(#arrPR)"/>
        ))}

        {/* Resultant force arrow */}
        <line x1="148" y1="210" x2="236" y2="160" stroke="#c0392b" strokeWidth="3.2" markerEnd="url(#arrPR)"/>
        <text x="126" y="226" fontFamily="Georgia,serif" fontSize="13" fontWeight="700" fill="#7B0D0D">F_R</text>

        {/* Centre of pressure */}
        <circle cx="236" cy="160" r="5" fill="#7B0D0D"/>
        <text x="244" y="157" fontFamily="Georgia,serif" fontSize="11" fill="#7B0D0D">Centre of pressure (y_cp)</text>

        {/* Centroid */}
        <circle cx="224" cy="148" r="4" fill="#2980b9"/>
        <text x="232" y="142" fontFamily="Georgia,serif" fontSize="11" fill="#2980b9">Centroid  ȳ</text>

        {/* Depth annotation */}
        <line x1="418" y1="50" x2="418" y2="152" stroke="#555" strokeWidth="1"
          markerEnd="url(#arrPB)" markerStart="url(#arrPT)"/>
        <text x="430" y="106" fontFamily="Courier New,monospace" fontSize="11" fill="#333">h̄</text>

        {/* Angle label */}
        <path d="M180 70 Q194 82 187 96" fill="none" stroke="#888" strokeWidth="1" strokeDasharray="3 2"/>
        <text x="196" y="92" fontFamily="Georgia,serif" fontSize="11" fill="#888">θ</text>

        {/* Formula box */}
        <rect x="420" y="170" width="248" height="118" rx="6" fill="#FEF0F0" stroke="#c0392b" strokeWidth="1"/>
        <text x="544" y="194" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="12" fontWeight="700" fill="#7B0D0D">F_R = ρg h̄ A</text>
        <line x1="430" y1="203" x2="658" y2="203" stroke="#f0cece" strokeWidth="1"/>
        <text x="544" y="220" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#555">h̄ = depth of centroid [m]</text>
        <text x="544" y="237" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#555">A = plate area [m²]</text>
        <text x="544" y="257" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="11" fill="#7B0D0D">y_cp = ȳ + I_c / (ȳ A)</text>
        <text x="544" y="277" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#555">I_c = 2nd moment of area</text>
      </svg>
      <div style={S.dCaption}>
        The resultant force equals the pressure at the centroid times the area. Because pressure increases with depth, F_R acts
        at the centre of pressure y_cp which always lies below the centroid. I_c is the second moment of area about the centroidal axis.
      </div>
    </div>
  );
}

// ── Diagram: Buoyancy ─────────────────────────────────────────────
function DiagramBuoyancy() {
  const W = 680, H = 300;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Archimedes' Principle — Buoyancy Force on Floating &amp; Submerged Bodies</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arrBU" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#27ae60"/>
          </marker>
          <marker id="arrBD" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#c0392b"/>
          </marker>
        </defs>

        {/* === Floating (left) === */}
        <rect x="30" y="100" width="180" height="170" fill="#2980b9" opacity="0.15" rx="4"/>
        <line x1="30" y1="100" x2="210" y2="100" stroke="#2980b9" strokeWidth="1.8"/>
        {/* object partially submerged */}
        <rect x="65" y="72" width="90" height="84" rx="6" fill="#e8d5a3" stroke="#8B6914" strokeWidth="1.5"/>
        <rect x="65" y="100" width="90" height="56" rx="0" fill="#2980b9" opacity="0.28"/>
        {/* F_B up */}
        <line x1="110" y1="220" x2="110" y2="132" stroke="#27ae60" strokeWidth="2.5" markerEnd="url(#arrBU)"/>
        <text x="120" y="184" fontFamily="Georgia,serif" fontSize="11" fill="#27ae60" fontWeight="700">F_B</text>
        {/* W down */}
        <line x1="110" y1="72" x2="110" y2="48" stroke="#c0392b" strokeWidth="2.5" markerEnd="url(#arrBD)"/>
        <text x="120" y="44" fontFamily="Georgia,serif" fontSize="11" fill="#c0392b" fontWeight="700">W</text>
        {/* B marker */}
        <circle cx="110" cy="128" r="4" fill="#27ae60"/>
        <text x="98" y="124" textAnchor="end" fontFamily="Georgia,serif" fontSize="10" fill="#27ae60">B</text>
        <text x="120" y="278" textAnchor="middle" fontFamily="Georgia,serif" fontSize="12" fontWeight="700" fill="#27ae60">Floating:  F_B = W</text>
        <text x="120" y="293" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#888">ρ_obj {'<'} ρ_fluid</text>

        {/* === Fully submerged (centre) === */}
        <rect x="240" y="50" width="180" height="220" fill="#2980b9" opacity="0.15" rx="4"/>
        <line x1="240" y1="50" x2="420" y2="50" stroke="#2980b9" strokeWidth="1.8"/>
        <rect x="280" y="130" width="80" height="70" rx="6" fill="#a8c8e8" stroke="#2980b9" strokeWidth="1.5"/>
        <line x1="320" y1="240" x2="320" y2="172" stroke="#27ae60" strokeWidth="2.5" markerEnd="url(#arrBU)"/>
        <text x="330" y="212" fontFamily="Georgia,serif" fontSize="11" fill="#27ae60" fontWeight="700">F_B</text>
        <line x1="320" y1="130" x2="320" y2="100" stroke="#c0392b" strokeWidth="2.5" markerEnd="url(#arrBD)"/>
        <text x="330" y="96" fontFamily="Georgia,serif" fontSize="11" fill="#c0392b" fontWeight="700">W</text>
        <circle cx="320" cy="165" r="4" fill="#27ae60"/>
        <text x="308" y="161" textAnchor="end" fontFamily="Georgia,serif" fontSize="10" fill="#27ae60">B</text>
        <text x="320" y="278" textAnchor="middle" fontFamily="Georgia,serif" fontSize="12" fontWeight="700" fill="#2980b9">Submerged:  F_B {'<'} W</text>
        <text x="320" y="293" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#888">ρ_obj {'>'} ρ_fluid</text>

        {/* Formula box */}
        <rect x="442" y="80" width="224" height="130" rx="6" fill="#FEF0F0" stroke="#c0392b" strokeWidth="1"/>
        <text x="554" y="106" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="13" fontWeight="700" fill="#7B0D0D">F_B = ρ_f g V_sub</text>
        <line x1="452" y1="116" x2="656" y2="116" stroke="#f0cece" strokeWidth="1"/>
        <text x="554" y="134" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#555">ρ_f = fluid density</text>
        <text x="554" y="151" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#555">V_sub = submerged volume</text>
        <text x="554" y="168" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#555">Acts upward through the</text>
        <text x="554" y="184" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#555">centre of buoyancy B</text>
      </svg>
      <div style={S.dCaption}>
        Left: floating body — buoyant force exactly equals weight, object sits at waterline.
        Centre: dense submerged body — weight exceeds buoyancy, net downward force.
        The buoyant force always acts upward through the centroid of the displaced volume (point B).
      </div>
    </div>
  );
}

// ── Diagram: Metacentre & Stability ──────────────────────────────
function DiagramMetacentre() {
  const W = 680, H = 290;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Metacentre &amp; Stability of Floating Bodies</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arrSW" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#c0392b"/>
          </marker>
          <marker id="arrSG" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#27ae60"/>
          </marker>
        </defs>

        {/* === Stable (left) === */}
        <rect x="30" y="128" width="210" height="132" fill="#2980b9" opacity="0.13" rx="4"/>
        <line x1="30" y1="128" x2="240" y2="128" stroke="#2980b9" strokeWidth="1.5"/>
        {/* tilted hull */}
        <g transform="rotate(-13, 135, 168)">
          <rect x="85" y="148" width="100" height="48" rx="6" fill="#e8d5a3" stroke="#8B6914" strokeWidth="1.5"/>
          <rect x="85" y="168" width="100" height="28" rx="0" fill="#2980b9" opacity="0.22"/>
        </g>
        {/* M */}
        <circle cx="135" cy="86" r="5" fill="#c0392b"/>
        <text x="143" y="84" fontFamily="Georgia,serif" fontSize="13" fontWeight="700" fill="#c0392b">M</text>
        {/* G */}
        <circle cx="135" cy="148" r="4" fill="#2980b9"/>
        <text x="143" y="152" fontFamily="Georgia,serif" fontSize="11" fill="#2980b9">G</text>
        {/* B */}
        <circle cx="138" cy="172" r="4" fill="#27ae60"/>
        <text x="146" y="176" fontFamily="Georgia,serif" fontSize="11" fill="#27ae60">B</text>
        {/* W arrow down */}
        <line x1="135" y1="148" x2="135" y2="204" stroke="#c0392b" strokeWidth="2" markerEnd="url(#arrSW)"/>
        {/* F_B arrow up */}
        <line x1="138" y1="172" x2="138" y2="106" stroke="#27ae60" strokeWidth="2" markerEnd="url(#arrSG)"/>
        {/* restoring couple arc */}
        <path d="M118 148 Q102 118 114 96" fill="none" stroke="#7B0D0D" strokeWidth="1.5" strokeDasharray="4 2"/>
        <text x="58" y="116" fontFamily="Georgia,serif" fontSize="10" fill="#7B0D0D">restoring</text>
        <text x="58" y="129" fontFamily="Georgia,serif" fontSize="10" fill="#7B0D0D">moment ↺</text>
        <text x="135" y="272" textAnchor="middle" fontFamily="Georgia,serif" fontSize="12" fontWeight="700" fill="#27ae60">STABLE  (M above G)</text>
        <text x="135" y="286" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#555">GM {'>'} 0</text>

        {/* === Unstable (right) === */}
        <rect x="270" y="128" width="210" height="132" fill="#2980b9" opacity="0.13" rx="4"/>
        <line x1="270" y1="128" x2="480" y2="128" stroke="#2980b9" strokeWidth="1.5"/>
        <g transform="rotate(-16, 375, 172)">
          <rect x="325" y="148" width="100" height="48" rx="6" fill="#e8d5a3" stroke="#8B6914" strokeWidth="1.5"/>
          <rect x="325" y="168" width="100" height="28" rx="0" fill="#2980b9" opacity="0.22"/>
        </g>
        {/* G above M */}
        <circle cx="375" cy="104" r="4" fill="#2980b9"/>
        <text x="383" y="108" fontFamily="Georgia,serif" fontSize="11" fill="#2980b9">G</text>
        <circle cx="375" cy="134" r="5" fill="#c0392b"/>
        <text x="383" y="132" fontFamily="Georgia,serif" fontSize="13" fontWeight="700" fill="#c0392b">M</text>
        <circle cx="378" cy="176" r="4" fill="#27ae60"/>
        <text x="386" y="180" fontFamily="Georgia,serif" fontSize="11" fill="#27ae60">B</text>
        <line x1="375" y1="104" x2="375" y2="204" stroke="#c0392b" strokeWidth="2" markerEnd="url(#arrSW)"/>
        <line x1="378" y1="176" x2="378" y2="108" stroke="#27ae60" strokeWidth="2" markerEnd="url(#arrSG)"/>
        <path d="M390 104 Q406 84 396 64" fill="none" stroke="#c0392b" strokeWidth="1.5" strokeDasharray="4 2"/>
        <text x="410" y="82" fontFamily="Georgia,serif" fontSize="10" fill="#c0392b">overturning</text>
        <text x="410" y="95" fontFamily="Georgia,serif" fontSize="10" fill="#c0392b">moment ↻</text>
        <text x="375" y="272" textAnchor="middle" fontFamily="Georgia,serif" fontSize="12" fontWeight="700" fill="#c0392b">UNSTABLE  (M below G)</text>
        <text x="375" y="286" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#555">GM {'<'} 0</text>

        {/* Formula box */}
        <rect x="500" y="96" width="170" height="96" rx="6" fill="#FEF0F0" stroke="#c0392b" strokeWidth="1"/>
        <text x="585" y="120" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="12" fontWeight="700" fill="#7B0D0D">GM = BM − BG</text>
        <line x1="510" y1="129" x2="660" y2="129" stroke="#f0cece" strokeWidth="1"/>
        <text x="585" y="147" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="11" fill="#7B0D0D">BM = I_wp / V_sub</text>
        <text x="585" y="164" textAnchor="middle" fontFamily="Georgia,serif" fontSize="10" fill="#555">I_wp = waterplane 2nd</text>
        <text x="585" y="179" textAnchor="middle" fontFamily="Georgia,serif" fontSize="10" fill="#555">moment of area</text>
      </svg>
      <div style={S.dCaption}>
        Left: M above G — weight (W↓) and buoyancy (F_B↑) form a restoring couple, returning the body to upright. Stable.
        Right: M below G — the couple acts to increase the tilt. Unstable. Metacentric height GM is the key design parameter.
      </div>
    </div>
  );
}

// ── Main export ───────────────────────────────────────────────────
export default function FluidStatics() {
  return (
    <div style={S.wrapper}>
      <h1 style={S.h1}>Fluid Statics</h1>
      <p style={S.p}>
        Fluid statics is the study of fluids at rest. When a fluid is stationary there is no shear stress —
        all internal forces arise from pressure acting normal to any surface. The governing principles
        underpin the design of dams, retaining walls, submarines, hydraulic presses, and ship hulls.
      </p>

      <InfoBox title="CORE CONCEPTS OVERVIEW" items={[
        "Pascal's Law — pressure applied to an enclosed fluid transmits equally in all directions",
        "Hydrostatic pressure — P = P₀ + ρgh; increases linearly with depth regardless of container shape",
        "Pressure measurement — manometers use fluid columns to measure gauge or differential pressure",
        "Forces on submerged surfaces — resultant acts at the centre of pressure, below the centroid",
        "Buoyancy — Archimedes: F_B = ρ_f g V_sub, acting upward through the centre of buoyancy B",
        "Stability — a floating body is stable when metacentre M lies above centre of gravity G (GM > 0)",
      ]}/>

      {/* ── Pascal's Law ── */}
      <h2 style={S.h2}>Pascal's Law &amp; Pressure Fundamentals</h2>
      <p style={S.p}>
        Pascal's law states that pressure applied to a confined, incompressible fluid is transmitted
        undiminished to every point in the fluid and to the walls of the container. This is the operating
        principle of hydraulic jacks, brakes, and presses — a small force over a small area produces a
        large force over a large area.
      </p>
      <Table2 rows={[
        ["Pascal's Law",
`Pressure at any point in a static fluid is equal in all directions
A small piston force transmits to a large piston force:
F₁/A₁ = F₂/A₂   (hydraulic multiplication)`],
        ["Pressure definition",
`P = F / A  [Pa = N/m²]
Scalar quantity in a static fluid — same in all directions at a point
1 bar = 10⁵ Pa;  1 atm = 101 325 Pa;  1 psi = 6895 Pa`],
        ["Absolute vs gauge pressure",
`P_absolute = P_gauge + P_atmospheric
P_atmospheric ≈ 101 325 Pa at sea level (1 atm)
Vacuum pressure: P_vac = P_atm − P_abs  (when P_abs < P_atm)`],
        ["Hydrostatic equation",
`dP/dz = −ρg   (z positive upward)
Integrating:  P₂ − P₁ = −ρg(z₂ − z₁) = ρg h
h = depth below reference point [m]`],
        ["Pressure head",
`h = P / (ρg)  [m of fluid]
Expresses pressure as equivalent fluid column height
Water: 1 m H₂O ≈ 9810 Pa;  Mercury: 1 m Hg ≈ 133 322 Pa`],
      ]}/>

      {/* ── Hydrostatic Pressure ── */}
      <h2 style={S.h2}>Hydrostatic Pressure Distribution</h2>
      <p style={S.p}>
        In a static fluid under gravity, pressure increases linearly with depth. This distribution is
        independent of the shape of the container — a consequence of Pascal's law sometimes called the
        hydrostatic paradox. The free surface is always a surface of constant pressure.
      </p>
      <DiagramHydrostaticPressure/>
      <Table2 rows={[
        ["Pressure with depth",
`P = P₀ + ρgh
P₀ = surface pressure [Pa],  ρ = fluid density [kg/m³]
g = 9.81 m/s²,  h = depth below free surface [m]`],
        ["Isobaric surfaces",
`Surfaces of constant pressure are horizontal planes in a static fluid
Free surface always at P = P_atm
Tilts if fluid is accelerating (see rigid-body motion section)`],
        ["Multi-layer fluids",
`P = P₀ + ρ₁g h₁ + ρ₂g h₂ + ...
Sum pressure contributions from each layer in sequence
Oil-water systems: ρ_oil ≈ 850 kg/m³ floats above ρ_water = 998 kg/m³`],
        ["Pressure in gases",
`For ideal gases: dP/dz = −ρg = −(PM/RT)g
Barometric formula: P = P₀ exp(−Mgz/RT)
Over small Δz in engineering problems, gas pressure variation often neglected`],
      ]}/>

      {/* ── Manometers ── */}
      <h2 style={S.h2}>Pressure Measurement — Manometers</h2>
      <p style={S.p}>
        A manometer measures pressure by balancing the unknown pressure against a column of fluid of known
        density. Simple U-tube manometers measure gauge or differential pressure directly; inclined
        manometers amplify the reading for improved precision on small pressure differences.
      </p>
      <DiagramManometer/>
      <Table2 rows={[
        ["Simple U-tube manometer",
`P_A + ρ₁g h₁ = P_B + ρ_m g h₂
For gauge pressure (P_B = P_atm):  P_gauge = ρ_m g Δh
Common manometer fluids: mercury SG = 13.6, water SG = 1.0`],
        ["Differential manometer",
`Measures pressure difference between two points A and B:
P_A − P_B = g (ρ_m − ρ_f) Δh
Used across orifice plates, venturi meters, and filters`],
        ["Inclined manometer",
`Δh = L sinθ  (L = reading along tube, θ = inclination angle)
Amplifies small differences: magnification factor = 1/sinθ
Typical θ = 5–15°; magnification ≈ 4–12× vs vertical tube`],
        ["Barometer (Torricelli)",
`P_atm = ρ_Hg g h   (h ≈ 760 mm Hg at sea level)
Invented 1644; defines standard atmosphere
1 atm = 101 325 Pa = 760 mmHg = 10.33 m H₂O`],
        ["Bourdon tube gauge",
`Curved tube straightens under internal pressure — drives pointer
Measures gauge pressure; ranges 0 to 700 MPa
Accuracy ≈ ±0.5–2% of full-scale deflection`],
      ]}/>

      {/* ── Forces on Submerged Surfaces ── */}
      <h2 style={S.h2}>Hydrostatic Forces on Submerged Surfaces</h2>
      <p style={S.p}>
        When a flat surface is submerged in a fluid, the linearly varying pressure with depth produces a
        net resultant force. Because pressure is greater at greater depth the resultant acts below the
        centroid of the surface — at the centre of pressure. This offset is critical in the design of
        dam gates, lock gates, and inspection hatches.
      </p>
      <DiagramSubmergedPlane/>
      <Table2 rows={[
        ["Resultant force on plane surface",
`F_R = ρg h̄ A
h̄ = vertical depth of centroid below free surface [m]
A = total surface area [m²]
Equivalent to average pressure (at centroid) × area`],
        ["Centre of pressure y_cp",
`y_cp = ȳ + I_c / (ȳ A)   [along inclined surface from free surface]
I_c = second moment of area about centroidal axis [m⁴]
y_cp ≥ ȳ — always at or below centroid; equals ȳ only if surface is horizontal`],
        ["Second moments of area I_c",
`Rectangle (b × d):     I_c = b d³ / 12
Circle (radius r):      I_c = π r⁴ / 4
Triangle (base b, height d):  I_c = b d³ / 36`],
        ["Forces on curved surfaces",
`Horizontal component F_H = force on vertical projection = ρg h̄ A_proj
Vertical component F_V = weight of fluid above curved surface (real or imaginary)
Resultant: F_R = √(F_H² + F_V²),  angle: tan α = F_V / F_H`],
        ["Pressure prism method",
`For rectangular surfaces: resultant = volume of pressure prism above surface
Acts at centroid of the prism (1/3 from base for triangular prism)
Quick check: confirms F_R and line of action without integration`],
      ]}/>

      {/* ── Buoyancy ── */}
      <h2 style={S.h2}>Buoyancy &amp; Archimedes' Principle</h2>
      <p style={S.p}>
        Archimedes' principle states that a body immersed in a fluid experiences an upward buoyant force
        equal to the weight of fluid it displaces. This determines whether an object floats, sinks, or
        hovers — and governs the design of ships, submarines, balloons, and density-measurement instruments.
      </p>
      <DiagramBuoyancy/>
      <Table2 rows={[
        ["Archimedes' principle",
`F_B = ρ_f g V_sub
ρ_f = fluid density,  V_sub = volume of fluid displaced
Acts upward through the centre of buoyancy B
(B = centroid of the displaced fluid volume)`],
        ["Floating condition",
`F_B = W  →  ρ_f V_sub = ρ_obj V_obj
Fraction submerged = ρ_obj / ρ_f
Object floats when ρ_obj < ρ_f  (e.g. wood in water)`],
        ["Submerged conditions",
`ρ_obj > ρ_f → net downward force → sinks
ρ_obj = ρ_f → neutrally buoyant → hovers at any depth
ρ_obj < ρ_f → net upward force → rises to surface`],
        ["Centre of buoyancy B",
`Centroid of the displaced fluid volume
Moves as body tilts (because displaced shape changes)
Distinct from G which is fixed to the body`],
        ["Hydrometer",
`Measures fluid density by depth of flotation: deeper → lower ρ_f
Calibrated directly in kg/m³ or specific gravity
Used in testing battery acid, wine fermentation, antifreeze`],
      ]}/>

      {/* ── Stability ── */}
      <h2 style={S.h2}>Stability of Floating &amp; Submerged Bodies</h2>
      <p style={S.p}>
        A floating body disturbed from equilibrium will return (stable), continue to capsize (unstable), or
        remain in the displaced position (neutral). Stability depends on the relative heights of the
        metacentre M, centre of gravity G, and centre of buoyancy B.
      </p>
      <DiagramMetacentre/>
      <Table2 rows={[
        ["Metacentre M",
`Point where the vertical line through the tilted buoyancy force B′
intersects the vessel's centreline
BM = I_wp / V_sub
I_wp = second moment of waterplane area about the tilt axis`],
        ["Metacentric height GM",
`GM = KB + BM − KG   (K = keel reference point)
  = I_wp / V_sub − BG
GM > 0 → stable;  GM < 0 → unstable;  GM = 0 → neutral`],
        ["Practical stability values",
`Cargo ships:    GM ≈ 0.3–1.0 m
Passenger ships: GM ≈ 0.5–1.5 m
Too large a GM → stiff, uncomfortable rolling
Too small a GM → sluggish return, capsize risk`],
        ["Stability of submerged bodies",
`B is fixed (= centroid of body volume, fully submerged)
Stable only if B is directly above G
Submarines: heavy ballast tanks placed low to keep G well below B`],
        ["Period of roll",
`T = 2π k / √(g GM)
k = radius of gyration of vessel about roll axis [m]
Large GM → short period (stiff);  small GM → long period (tender)`],
      ]}/>

      {/* ── Rigid-Body Motion ── */}
      <h2 style={S.h2}>Fluids in Rigid-Body Motion</h2>
      <p style={S.p}>
        A fluid undergoing uniform linear acceleration or solid-body rotation has no relative motion between
        particles — shear stresses remain zero — and is analysed with the same hydrostatic framework using
        an effective body force that replaces gravity.
      </p>
      <Table2 rows={[
        ["Linear acceleration",
`Modified pressure gradient: ∇P = ρ(g − a)
Horizontal acceleration a_x:  dP/dx = −ρ a_x,  dP/dz = −ρg
Free surface tilts: tan θ = a_x / g`],
        ["Rotating container (forced vortex)",
`Solid-body rotation at ω rad/s: V_θ = ω r  (every particle same ω)
Pressure: P = P_centre + ½ρω²r² − ρgz
Free surface forms a paraboloid: z = z₀ + ω²r²/(2g)`],
        ["Paraboloid geometry",
`Rise at rim R above centre: Δh = ω²R² / (2g)
Volume of fluid is conserved; paraboloid vertex drops by Δh/2
Used in spin-casting of telescope mirrors and parabolic antenna blanks`],
      ]}/>

      {/* ── Summary ── */}
      <h2 style={S.h2}>Key Formulae Summary</h2>
      <InfoBox title="FLUID STATICS — QUICK REFERENCE" items={[
        "Hydrostatic pressure:              P = P₀ + ρgh  [Pa]",
        "Pascal's law (hydraulic):          F₁/A₁ = F₂/A₂",
        "U-tube manometer:                 P_gauge = ρ_m g Δh",
        "Differential manometer:           P_A − P_B = g(ρ_m − ρ_f) Δh",
        "Resultant force on plane surface:  F_R = ρg h̄ A",
        "Centre of pressure:               y_cp = ȳ + I_c / (ȳ A)",
        "Buoyant force (Archimedes):        F_B = ρ_f g V_sub",
        "Floating condition:               ρ_obj / ρ_f = V_sub / V_obj",
        "Metacentric height:               GM = I_wp / V_sub − BG",
        "Stability condition:              GM > 0 → stable;  GM < 0 → unstable",
        "Linear accel. surface tilt:       tan θ = a_x / g",
        "Rotating fluid paraboloid:        z = z₀ + ω²r² / (2g)",
      ]}/>
    </div>
  );
}